import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// export const getLanguage = createAsyncThunk('getLanguage', ({lang}) => {
//     const language = lang   
//     return language
// })
export const languageSlice = createSlice({
    name: 'language',
    initialState: {
        language: 'en'
    },
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload
        }
    }
    // extraReducers: builder => {
    //     builder
    //         .addCase(getLanguage.fulfilled, (state, action) => {
    //             state.language = action.payload
    //         })
    // }
})
export const { setLanguage } = languageSlice.actions
export default languageSlice.reducer